import Vue from 'vue'
import Vuex from 'vuex'
import userStore from './modules/user'
import recordStore from './modules/record'
import deviceStore from './modules/device'
import employeeStore from './modules/employee'
import groupStore from './modules/group'
import organizationStore from './modules/organization'

Vue.use(Vuex)

class State {
  isLogin: boolean = false
  currentPage: number | null = null
}

export default new Vuex.Store({
  state: new State(),
  mutations: {
    setLogin(state, status) {
      state.isLogin = status
    },
    setCurrentPage(state, page) {
      state.currentPage = page
    }
  },
  actions: {
  },
  modules: {
    userStore,
    recordStore,
    deviceStore,
    employeeStore,
    groupStore,
    organizationStore
  }
})
